import { useQuery } from '@tanstack/react-query';
import { getQuoteProgress } from '../../api';
import { ProductTypes } from '../../types';

export const useGetQuoteSubjectivityStatus = ({
  quoteId,
  productType,
}: any) => {
  const query = useQuery(
    ['p250-quote-can-customer-bind-attest', quoteId],
    () => {
      if ([ProductTypes.p100, ProductTypes.p250].includes(productType)) {
        return getQuoteProgress(quoteId).then(({ data }: any) => data);
      }
    },
    {
      refetchOnWindowFocus: true,
      keepPreviousData: true,
      enabled: !!quoteId,
    }
  );

  const { data: subjectivityData = {} } = query;
  const { preBindSubjectivities = [], preIssuanceSubjectivities = [] } =
    subjectivityData;
  const incompletePreBindSubjectivities = preBindSubjectivities.filter(
    ({ completed, verified }: any) => !completed && !verified
  );
  const incompletePreIssuanceSubjectivites = preIssuanceSubjectivities.filter(
    ({ completed, verified }: any) => !completed && !verified
  );

  let canQuoteBeApproved = false;
  let canUserAttest = false;

  if (productType === ProductTypes.p100) {
    canQuoteBeApproved = Boolean(!incompletePreBindSubjectivities.length);
    canUserAttest = true;
  } else if (productType === ProductTypes.p250) {
    canQuoteBeApproved =
      Boolean(!incompletePreBindSubjectivities.length) &&
      Boolean(!incompletePreIssuanceSubjectivites.length);
    canUserAttest = Boolean(!incompletePreIssuanceSubjectivites.length);
  }

  return {
    query,
    canQuoteBeApproved,
    canUserAttest,
  };
};
